(() => {
  const benefitTimers = new WeakMap();

  const initBenefits = (root) => {
    const track = root.querySelector('[data-jt-benefits-track]');
    const items = Array.from(root.querySelectorAll('[data-jt-benefit]'));
    if (!track || items.length < 2 || benefitTimers.has(track)) return;

    let index = 0;
    const rotate = () => {
      if (!window.matchMedia('(max-width: 989px)').matches || document.hidden) return;
      index = (index + 1) % items.length;
      track.scrollTo({ left: items[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      benefitTimers.set(track, window.setInterval(rotate, 3200));
    }
  };

  const init = (root) => {
    if (!root || root.dataset.jeeteeReady === 'true') return;
    root.dataset.jeeteeReady = 'true';
    initBenefits(root);
    const items = root.querySelectorAll('[data-jt-reveal]');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((item) => observer.observe(item));
  };

  const boot = () => document.querySelectorAll('[data-jeetee-home]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-jeetee-home]')));
})();
